import { Link } from '@reach/router';
import styled from 'styled-components/macro';
import {
  focusRing,
  fontSize,
  fontWeight,
  lineHeight,
  media,
  radius,
  space,
} from '../../../theme/tokens';
import { RoundProfileImage } from '../../common/elements/ProfileImage';
import { StaffCard } from '../../common/elements/Staff';

export const UserCard = styled(StaffCard)`
  width: 100%;

  ${media.md`
    width: 24rem;
  `}
`;

export const UserLink = styled(Link)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: start;
  gap: ${space[3]};
  min-width: 0;
  text-decoration: none;
  color: inherit;
  border-radius: ${radius.md};
  ${focusRing}
`;

export const UserProfileImage = styled(RoundProfileImage)`
  flex-shrink: 0;
  /* avatar box size */
  height: 4.8rem;
  width: 4.8rem;
`;

export const UserDisplayName = styled.p`
  font-weight: ${fontWeight.semibold};
  font-size: ${fontSize.md};
  line-height: ${lineHeight.tight};
  color: ${({ theme }) => theme.staffCardHeaderColour};
  overflow-wrap: anywhere;
`;

export const UserCategory = styled.span`
  font-weight: ${fontWeight.medium};
  font-size: ${fontSize.xs};
  color: ${({ theme }) => theme.staffCardHeaderColour};
  display: inline-block;
  margin-top: ${space[1]};
  padding-right: ${space[2]};
`;

export const PWithSubscript = styled.div`
  min-width: 0;

  ${UserDisplayName} {
    margin: 0;
    padding-left: 0;
  }

  ${UserCard} {
    width: 24rem;
  }
`;
